'use client';
import React, { useState } from 'react';

import { cn } from '@/lib/utils';

import { IconButton } from '@/decodo/components/atoms/IconButton';
import { Modal } from '@/decodo/components/atoms/Modal';
import { Video, VideoProps } from '@/decodo/components/atoms/Video';

import IconPlayButton from '~/svg/IconPlayVideo.svg';

export interface VideoPopupProps {
  renderVideo?: (props: Partial<VideoProps>) => React.ReactNode;
  videoProps?: VideoProps;
  classNames?: {
    root?: string;
    targetWrapper?: string;
    iconWrapper?: string;
  };
  icon?: React.ReactNode;
}

export const VideoPopup = ({
  renderVideo,
  videoProps,
  classNames,
  icon,
}: VideoPopupProps) => {
  const [isOpen, setIsOpen] = useState(false);

  function handleChange(open: boolean) {
    setIsOpen(open);
  }

  return (
    <>
      <div
        className={cn(classNames?.targetWrapper)}
        data-tracker-component='video-popup-close'
      >
        <IconButton
          onClick={() => handleChange(true)}
          variant='text'
          classNames={{
            root: cn(
              'bg-base-black/20 hover:bg-base-black/40 h-20 w-20 rounded-full',
              classNames?.root
            ),
            inner: 'justify-center',
          }}
        >
          {icon || <IconPlayButton className='text-base-black' />}
        </IconButton>
      </div>
      <Modal
        isOpen={isOpen}
        onClose={() => handleChange(false)}
        closeIsOutside
        overlayProps={{ darkOverlay: true }}
        hasClose={true}
        classNames={{
          modal:
            'bg-transperant border-none shadow-none w-full animate-zoom-in md:w-3/4 p-0 static',
          close:
            'absolute top-20 right-6 z-50 text-base-white w-6 bg-base-black/20 hover:bg-base-black/40 h-6 rounded-full',
        }}
      >
        {isOpen &&
          (renderVideo
            ? renderVideo({
                classNames: { container: 'w-full', ...videoProps?.classNames },
              })
            : videoProps && (
                <Video
                  {...videoProps}
                  classNames={{ container: 'w-full', ...videoProps.classNames }}
                />
              ))}
      </Modal>
    </>
  );
};
